export const getArticleCount = (element) => {
  const count = element.getAttribute("data-articles-count");
  return count ? parseInt(count) : 100;
};
